import { create } from 'zustand';

export interface PageFootnote {
  name: string;
  content: string;
}

export interface IndexedPageFootnote {
  index: number;
  footnote: PageFootnote;
}

interface PageFootnoteStore {
  footnotes: Map<string, IndexedPageFootnote>;
  registerFootnote: (footnote: PageFootnote) => void;
  clearFootnotes: () => void;
  getFootnotes: () => IndexedPageFootnote[];
  getFootnote: (name: string) => IndexedPageFootnote | undefined;
}

export const usePageFootnotes = create<PageFootnoteStore>((set, get) => ({
  footnotes: new Map(),
  registerFootnote: (footnote) =>
    set((state) => {
      const newfootnotes = new Map(state.footnotes);
      if (!newfootnotes.has(footnote.name)) {
        const index = newfootnotes.size + 1;
        newfootnotes.set(footnote.name, { index, footnote });
      }
      return { footnotes: newfootnotes };
    }),
  clearFootnotes: () => {
    set(() => ({
      footnotes: new Map(),
    }));
  },
  getFootnotes: () => [...get().footnotes.values()],
  getFootnote: (name: string) => get().footnotes.get(name),
}));
